import {
  SET_AUTHENTICATED
} from './mutation-types'

export default {
  [SET_AUTHENTICATED]: (state, { authenticated }) => {
    state.authenticated = authenticated
  }
}
